import { Drawer } from "flowbite-react";
import Navbar from "./components/DashboardHeader";
import Sidebar from "./components/Sidebar";
import { useEffect, useState } from "react";
import SettingsModal from "./components/Settings";
import { useSelector } from "react-redux";

const DashboardLayout = function ({ children }) {
  const [openSettings, setOpenSettings] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const user = useSelector((state) => state.Auth.authData);

  useEffect(() => {
    if (user && !user?.company?._id && !openSettings) {
      setOpenSettings(true);
    }
  }, [user, openSettings]);

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };
  const handleCloseSettings = () => {
    if (user && user?.company?._id && openSettings) {
      setOpenSettings(false);
    }
  };
  return (
    <>
      <Navbar setIsDrawerOpen={setIsDrawerOpen} />
      <div className="flex items-start h-[calc(100vh-76px)] bg-[#F9FAFB]">
        <Sidebar
          setOpenSettings={setOpenSettings}
          openSettings={openSettings}
        />
        <Drawer
          open={isDrawerOpen}
          onClose={handleCloseDrawer}
          className="bg-[#F9FAFB]"
        >
          <Drawer.Header title="MENU" titleIcon={() => <></>} />
          <Drawer.Items className="h-[calc(100vh-72px)]">
            <Sidebar
              isDrawr={true}
              setOpenSettings={setOpenSettings}
              openSettings={openSettings}
            />
          </Drawer.Items>
        </Drawer>
        <MainContent>{children}</MainContent>
        {openSettings ? (
          <SettingsModal handleCloseSettings={handleCloseSettings} />
        ) : null}
      </div>
    </>
  );
};

const MainContent = ({ children }) => {
  return (
    <main className="h-full w-full overflow-y-auto bg-white rounded-2xl">
      {children}
    </main>
  );
};

export default DashboardLayout;
